// extracted by mini-css-extract-plugin
export default {"mainform":"FoodOrderForm_mainform__a5OgQ","inputbox":"FoodOrderForm_inputbox__zJU4G","formbutton":"FoodOrderForm_formbutton__A-AcZ","label":"FoodOrderForm_label__2ewbE"};